// extracted by mini-css-extract-plugin
export default {"fs":"ab5758abcb _66818a2269"};